module.exports = __webpack_public_path__ + "static/media/iPhone-mockup.23f3594d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iPhone-mockup.svg
// module id = 2075
// module chunks = 0